import { render, staticRenderFns } from "./Headbar.vue?vue&type=template&id=2f96f13e&scoped=true"
import script from "./Headbar.vue?vue&type=script&lang=js"
export * from "./Headbar.vue?vue&type=script&lang=js"
import style0 from "./Headbar.vue?vue&type=style&index=0&id=2f96f13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f96f13e",
  null
  
)

export default component.exports